import { useShortcut as useShortcut$1 } from '@i-ark/hooks';
import { componentFrameworkStore } from '@provider/component-framework';
import { iArkStore } from '../state/store.js';

function useShortcut(command, listener) {
  const enabled = iArkStore.useSelector(state => state.component.envelope.ID) === componentFrameworkStore.useSelector(state => state.activeComponentId);
  return useShortcut$1(command, listener, {
    enabled
  });
}

export { useShortcut };
//# sourceMappingURL=hook.use-shortcut.js.map
